import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { Show, Toggle } from '@/components/Accordion'

const Section = ({
  children,
  condition,
  eventKey,
  title
}) => {
  const currentKey = useSelector(state => state.accordion.eventKey)

  const isShowing = currentKey === eventKey

  return (
    <>
      <If condition={condition}>
        <h2 className='vs-collapse-heading' id={`scroll-target-${eventKey}`}>
          <Toggle
            as='button'
            className={`vs-collapse-toggle collapse-panel-${eventKey}
              u-weight--bold p-3`
            }
            eventKey={eventKey}
            id={eventKey}
          >
            {title}
          </Toggle>
        </h2>
        <If condition={isShowing}>
          <Show eventKey={eventKey}>
            <div className='vs-collapse-content p-3'>
              {children}
            </div>
          </Show>
        </If>
      </If>
    </>
)}

export default Section

Section.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  condition: PropTypes.bool.isRequired,
  eventKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
}
